module.exports = __webpack_public_path__ + "static/portfolio3e-4186dd944eed27f846dbe43a1e43dc7c.jpg";